import { ENV } from '@forwardflow/helpers/configs'
import Icon from '@forwardflow/ui/Icons'
import { useSearchParams } from 'react-router-dom'


interface SocialLoginProps {
   demoBookingId?: number
}

const SocialLogin: React.FC<SocialLoginProps> = ({ demoBookingId }) => {
   const [searchParams] = useSearchParams()
   const invitationToken = searchParams.get('invitationToken')

   const buildRedirectUrl = () => {
      let baseUrl = `${ENV.PUBLIC_FF_URL}auth/google?redirectUrl=${window.location.origin}`
      if (demoBookingId) {
         baseUrl += `&demoBookingId=${demoBookingId}`
      }
      if (invitationToken) {
         baseUrl += `&invitationToken=${invitationToken}`
      }

      return baseUrl
   }

   return (
      <>
         <a
            className="rounded-xl group text-[14px] md:text-[18px] bg-black/40 h-14 md:h-[70px] max-w-[450px] w-full flexc relative border border-white/10 hover:border-white hover:bg-primary transition"
            href={buildRedirectUrl()}
         >
            <Icon
               name="google-icon"
               className="absolute left-8 group-hover:brightness-0 group-hover:invert-[1] w-5 md:w-6"
            />
            <span>Continue with Google</span>
         </a>
      </>
   )
}

export default SocialLogin
